import { render, staticRenderFns } from "./SubmissionPublic.vue?vue&type=template&id=170aaefc&"
import script from "./SubmissionPublic.vue?vue&type=script&lang=js&"
export * from "./SubmissionPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports